<template>
  <section class="contact-section py-5">
    <!-- Fondo de imagen -->
    <div class="contact-bg"></div>

    <div class="container position-relative">
      <!-- Bienvenida -->
      <div class="text-center mb-5 text-white">
        <h1 class="contact-title fade-in">¡Bienvenido a Victoria Gym!</h1>
        <p class="contact-subtitle fade-in" style="animation-delay: 0.2s;">
          “𝐸𝑙 𝑐𝑢𝑒𝑟𝑝𝑜 𝑎𝑙𝑐𝑎𝑛𝑧𝑎 𝑙𝑜 𝑞𝑢𝑒 𝑙𝑎 𝑚𝑒𝑛𝑡𝑒 𝑐𝑟𝑒𝑒”<br>
          Desde 2011
        </p>
      </div>

      <div class="row align-items-start g-4">
        <!-- Columna izquierda: Bloques de info -->
        <div class="col-lg-5 d-flex flex-column gap-3">
          <div class="info-card fade-in" style="animation-delay: 0.3s;">
            <i class="bi bi-clock-fill info-icon me-2"></i>
            <div>
              <h6 class="info-title mb-1">Horario</h6>
              <p class="mb-0">Lunes a viernes: 5:00am - 10:00pm<br>Sábados: 6:00am - 1:00pm</p>
            </div>
          </div>

          <div class="info-card fade-in" style="animation-delay: 0.4s;">
            <i class="bi bi-geo-alt-fill info-icon me-2"></i>
            <div>
              <h6 class="info-title mb-1">Ubicación</h6>
              <p class="mb-0">C.C Latin Center, Local 20 y 21<br>Calle 30 con Av. 33, Portuguesa, Acarigua 3301</p>
            </div>
          </div>

          <div class="info-card fade-in" style="animation-delay: 0.5s;">
            <i class="bi bi-whatsapp info-icon me-2"></i>
            <div>
              <h6 class="info-title mb-1">WhatsApp</h6>
              <p class="mb-0">
                <a href="https://wa.me/584143516746" target="_blank" class="contact-link">0414-3516746</a>
              </p>
            </div>
          </div>

          <div class="info-card fade-in" style="animation-delay: 0.6s;">
            <i class="bi bi-envelope-fill info-icon me-2"></i>
            <div>
              <h6 class="info-title mb-1">Correo</h6>
              <p class="mb-0">
                <a href="mailto:victoriafitnesscenterca@gmail.com" class="contact-link">
                  victoriafitnesscenterca@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- Columna derecha: Formulario -->
        <div class="col-lg-7">
          <div class="form-card fade-in" style="animation-delay: 0.7s;">
            <form @submit.prevent="enviarWhatsApp">
              <div class="mb-3">
                <label for="name" class="form-label">Nombre</label>
                <input v-model="form.name" type="text" id="name" class="form-control" placeholder="Tu nombre" required />
              </div>
              <div class="mb-3">
                <label for="email" class="form-label">Correo electrónico</label>
                <input v-model="form.email" type="email" id="email" class="form-control" placeholder="tu@email.com" required />
              </div>
              <div class="mb-3">
                <label for="subject" class="form-label">Asunto</label>
                <input v-model="form.subject" type="text" id="subject" class="form-control" placeholder="Asunto del mensaje" />
              </div>
              <div class="mb-3">
                <label for="message" class="form-label">Mensaje</label>
                <textarea v-model="form.message" id="message" rows="6" class="form-control" placeholder="Escribe tu mensaje aquí..." required></textarea>
              </div>
              <button type="submit" class="btn cta-btn w-100 fw-bold">
                <i class="bi bi-whatsapp me-2"></i> Enviar por WhatsApp
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive } from 'vue'
import 'bootstrap-icons/font/bootstrap-icons.css'

const form = reactive({
  name: '',
  email: '',
  subject: '',
  message: ''
})

// Mensaje que envía el usuario
const enviarWhatsApp = () => {
  const phone = '584143516746'
  const text = 
    `👋 ¡Hola Victoria Gym!%0A%0A` +
    `🧑 Nombre: ${form.name}%0A` +
    `📧 Correo: ${form.email}%0A` +
    `📌 Asunto: ${form.subject}%0A` +
    `📝 Mensaje: ${form.message}%0A%0A` +
    `Espero su respuesta, ¡gracias! 🙌`
  
  const url = `https://wa.me/${phone}?text=${text}`
  window.open(url, '_blank')
}
</script>

<style scoped>
.contact-section {
  position: relative;
  font-family: 'Poppins', sans-serif;
  overflow: hidden;
  padding-bottom: 6rem;
}

.contact-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('@/assets/images/carruzel/gym1.webp') center/cover no-repeat;
  filter: brightness(0.4);
  z-index: 0;
}

.contact-title { font-size: 2.5rem; font-weight: 700; color: #F97316; }
.contact-subtitle { font-size: 1.1rem; color: #FBBF24; }

.form-card {
  background-color: #fff;
      color: chocolate;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 8px 20px rgba(0,0,0,0.3);
  position: relative;
  z-index: 1;
}
.form-control { border-radius: 0.5rem; border: 1px solid #ccc; }
.form-control:focus { border-color: #F97316; box-shadow: 0 0 8px rgba(249,115,22,0.4); }
.cta-btn { background-color: #25D366; color: #fff; transition: transform 0.3s ease, box-shadow 0.3s ease; }
.cta-btn:hover { transform: scale(1.05); box-shadow: 0 0 12px rgba(37,211,102,0.6); }

.info-card {
  background-color: #fff;
      color: chocolate;
  padding: 1.5rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 6px 15px rgba(0,0,0,0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.info-card:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.3); }
.info-icon { font-size: 1.8rem; color: #F97316; animation: bounce 2s infinite; }
.info-title { font-weight: 600; margin-bottom: 0.3rem; }
.contact-link { color: #111; text-decoration: none; }
.contact-link:hover { color: #F97316; text-decoration: underline; }

@keyframes bounce { 0%,100%{transform:translateY(0);}50%{transform:translateY(-5px);} }
.fade-in { opacity: 0; transform: translateY(10px); animation: fadeInUp 0.8s forwards; }
@keyframes fadeInUp { to { opacity: 1; transform: translateY(0); } }

@media (max-width: 992px) {
  .row.align-items-start { flex-direction: column-reverse; }
  .info-card { justify-content: center; text-align: center; }
  .info-card i { margin-bottom: 0.5rem; }
}
</style>
